import axios from 'axios';
import deepMapKeys from 'deep-map-keys';
import { snakeCase, camelCase, isPlainObject } from 'lodash';
import { getToken, setToken } from './auth';
import store from '../store';

export const baseURL = process.env.API_URL;

const instance = axios.create({
  baseURL: `${baseURL}api/`,
});

export function setAuthToken(token) {
  if (!token) return;

  instance.defaults.headers.common.Authorization = `Bearer ${token}`;
}

function isValidJSON(value) {
  try {
    JSON.parse(value);
    return true;
  } catch (e) {
    return false;
  }
}

function deepMapData(data, mapper) {
  if (isPlainObject(data) || Array.isArray(data)) {
    return deepMapKeys(data, mapper);
  } else if (isValidJSON(data)) {
    return JSON.stringify(deepMapKeys(JSON.parse(data), snakeCase));
  }
  return data;
}

setAuthToken(getToken());

instance.defaults.transformRequest.push(data => deepMapData(data, snakeCase));

instance.defaults.transformResponse.push(data => deepMapData(data, camelCase));

instance.interceptors.request.use(config => {
  // eslint-disable-next-line no-param-reassign
  config.headers['Accept-Language'] = 'it_IT';

  if (store.state && store.state.season) {
    // eslint-disable-next-line no-param-reassign
    config.params = {
      ...config.params,
      season_id: store.state.season.id,
    };
  }

  return config;
});

/* eslint-disable no-underscore-dangle */
instance.interceptors.response.use(
  res => res,
  error => {
    const { config: originalConfig, response } = error;
    const originalRequest = originalConfig;

    if (
      response &&
      response.data.error &&
      Number(response.data.error.error_code) === 101 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      instance
        .get('auth/refresh', {
          headers: { Authorization: originalRequest.headers.Authorization },
        })
        .then(({ headers }) => {
          const newToken = headers.authorization;

          if (newToken) {
            setToken(newToken);
            setAuthToken(newToken);
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
          }

          return instance(originalRequest);
        });
    }

    return Promise.reject(error);
  },
);

export default instance;



// WEBPACK FOOTER //
// ./src/lib/axios.js